<template>
  <div class="hello">
    <modal
      height="auto"
      classes="msg-modal"
      width="300px"
      :adaptive="true"
      name="message"
      >{{ msg }}</modal
    >
    <div>
      <img class="tp-logo" alt="TokenPocket logo" src="../assets/logo.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {};
  },
  created() {},
  methods: {
    changeLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("locale", lang);
      if (lang === "en") {
        Settings.defaultLocale = "en-US";
      } else {
        Settings.defaultLocale = "zh-CN";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
